module.exports = __webpack_public_path__ + "img/outwards-agility.25adbab8.png";